<template>
  <div class="tabs">
    <button
      v-for="tab in tabs"
      :key="tab"
      class="tabs__tab button--40"
      :class="activeTabLocal === tab ? 'is-active' : 'button--secondary'"
      @click="changeTab(tab)"
    >
      {{ tab }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    tabs: {
      type: Array,
      default: () => []
    },
    activeTab: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      activeTabLocal: this.activeTab,
    }
  },
  methods: {
    changeTab (tab) {
      this.activeTabLocal = tab
      this.$emit('tabChange', tab)
    }
  }
}
</script>

<style lang="scss">
  .tabs {
    display: flex;
    justify-content: space-around;
    border-bottom: 2px solid $color-red-dark;
    margin-top: 1rem;

    @include media-breakpoint-up(md) {
      margin-top: 1.5rem;
    }

    .tabs__tab {
      flex-grow: 1;
      margin-right: 1rem;
      width: 100%;
      height: 40px;
      padding: 0.5rem;
      line-height: 1.5rem;
      border: none;
      border-radius: 1.5rem 1.5rem 0 0;

      &:first-child {
        margin-left: 1rem;
      }

      @include media-breakpoint-up(md) {
        &:first-child {
          margin-left: 1.5rem;
        }

        &:last-child {
          margin-right: 1.5rem;
        }
      }

      &.is-active {
        font-weight: 900;
        background-color: $color-red-dark;
      }
    }
  }
</style>
